import { render, staticRenderFns } from "./Orders.vue?vue&type=template&id=3c054ee7&scoped=true"
import script from "./Orders.vue?vue&type=script&lang=js"
export * from "./Orders.vue?vue&type=script&lang=js"
import style0 from "./Orders.vue?vue&type=style&index=0&id=3c054ee7&prod&scoped=true&lang=css"
import style1 from "./Orders.vue?vue&type=style&index=1&id=3c054ee7&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c054ee7",
  null
  
)

export default component.exports